import { hot } from 'react-hot-loader';
import Seo from '../components/Seo';
import Footer from '../components/Footer';
import ScreenTerms from '../screens/ScreenTerms';



function TermsPage(props) {
  return (
    <Seo title={'Terms & Conditions'} meta={[]}>
      <ScreenTerms />
      <Footer />
    </Seo>
  );
};

export default hot(module)(TermsPage);
